export type PublicRuntimeConfig = {
  apiHost: string;
  posthogHost: string;
  posthogKey: string;
};

export async function getRuntimeConfig(): Promise<PublicRuntimeConfig> {
  const response = await fetch("/api/runtime-config", {
    cache: "no-store",
  });

  if (!response.ok) {
    throw new Error(`Failed to load runtime config: ${response.status}`);
  }

  return response.json();
}
